var React = require('react');

function GlobalBtnMenu (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"global__btn__menu","fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1"},[React.createElement("rect",{"id":"top","width":"32","height":"5","x":"6","y":"14","fill":"#1A1A3D","key":0}),React.createElement("rect",{"id":"bottom","width":"32","height":"5","x":"6","y":"25","fill":"#1A1A3D","key":1})]));
}

GlobalBtnMenu.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44"};

module.exports = GlobalBtnMenu;

GlobalBtnMenu.default = GlobalBtnMenu;
